import React, { useEffect, useState } from 'react'
import SaveTasks from '../../services/general/TaskCrud.api'
import { CButton, CCardTitle, CDropdown, CDropdownItem, CDropdownMenu, CDropdownToggle, CFormInput, CFormLabel, CFormTextarea, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react'
import { Cog, LayoutPanelLeft, Plus, Settings2, X } from 'lucide-react'
import { toastConfig } from '../../constants/other.config'
import toast from 'react-hot-toast'
import { AnimatePresence, motion } from 'framer-motion'
 
import { ColumnDirective, ColumnsDirective, KanbanComponent } from '@syncfusion/ej2-react-kanban'
import { addClass } from '@syncfusion/ej2-base'
import RegisterUser from '../../services/general/register.api'
import { Pending } from '@mui/icons-material'
import Pageloader from '../../components/shared/Pageloader'
import Select from 'react-select'

const TempBacklog = () => {
    const [todos, setTodos] = useState([])
    const [loading, setLoading] = useState(true)
    const [editModalVisible, setEditModalVisible] = useState(false);
    const [selectedBoardId, setSelectedBoardId] = useState("")
    const [showBoards, setShowBoards] = useState(false)
    const [tasks, setTasks] = useState([])
    const [filters, setFilters] = useState({
        date: '',
        assignee: '',
    })


    console.log("todoss data " , todos)
    const [createBoardState, setCreateBoardState] = useState({
        id: Date.now(),
        title: '',
        description: '',
        tasks: [],
        columns: []
    })


    const [users, setUsers] = useState([])

    console.log(users, 'users')

    const GetAllUsers = async () => {
        const response = await RegisterUser('', '', '', '', 'get_all')
        let allUsers = response?.d
        allUsers = allUsers.Users
        console.log(allUsers, 'allUsers')
        if (allUsers.length > 0) {

            setUsers(allUsers.map((item) => {
                return {
                    name: item.Username,
                    label: item.Username,
                    value: item?.Id,
                    role: "office"
                }
            }))
        }
    }

    useEffect(() => {
        GetAllUsers()
    }, [])

    const getTodos = async () => {
        try {
            const { data, error } = await supabase
                .from('boards')
                .select('*')

            if (error) {
                console.error('Supabase error:', error)
                return
            }

            console.log('todos data:', data)
            setTodos(data || [])
        } catch (err) {
            console.error('Unexpected error:', err)
        } finally {
            setLoading(false)
        }
    }
    const getTask = async () => {
        try {
            const { data, error } = await supabase
                .from('tasks')
                .select('title,assignee,status,dueDate,boardId')

            if (error) {
                console.error('Supabase error:', error)
                return
            }
            // let { data: tasks, error } = await supabase  .from('tasks')  .select("*")  // Filters  .eq('column', 'Equal to')  .gt('column', 'Greater than')  .lt('column', 'Less than')  .gte('column', 'Greater than or equal to')  .lte('column', 'Less than or equal to')  .like('column', '%CaseSensitive%')  .ilike('column', '%CaseInsensitive%')  .is('column', null)  .in('column', ['Array', 'Values'])  .neq('column', 'Not equal to')

            console.log('task', data)
            setTasks(data || [])
        } catch (err) {
            console.error('Unexpected error:', err)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getTodos()
        getTask()
    }, [])


    const handleSaveBoard = async () => {
        const boardPayload = {
            title: createBoardState.title,
            description: createBoardState.description,
            columns: createBoardState.columns
        };



        const { data, error } = await supabase
            .from("boards")
            .insert([boardPayload])
            .select()
            .single();

        if (error) {
            console.error("Error creating board:", error);
            return;
        }

        console.log("Board created:", createBoardState, data, boardPayload);
        getTodos()
        getTask()
        setEditModalVisible(false)
        setCreateBoardState({
            id: Date.now(),
            title: '',
            description: '',
            tasks: [],
            columns: []
        })
        toast.success("Board Added successfully", toastConfig)

    }
    const filteredTasks = () => {
        let result = [...tasks]

        // Date filter
        if (filters.date) {
            const selectedDate = new Date(filters.date)
            selectedDate.setHours(23, 59, 59, 999)

            result = result.filter(task => {
                if (!task.dueDate) return false
                return new Date(task.dueDate) <= selectedDate
            })
        }

        // Assignee filter
        console.log("filter data", filters, tasks)
        if (filters.assignee) {
            result = result.filter(task =>
                task.assignee?.toLowerCase() === filters.assignee.toLowerCase()
            )
        }

        console.log('filteredTasks', result)
        return result
    }



    //   useEffect(() => {
    //     const createBoard = async () => {
    //       const boardPayload = {
    //         title: "My First Board",
    //         description: "Board created on first load",
    //         columns: [
    //           { id: "todo", name: "Todo", order: 1 },
    //           { id: "in_progress", name: "In Progress", order: 2 },
    //           { id: "done", name: "Done", order: 3 }
    //         ]
    //       };

    //       const { data, error } = await supabase
    //         .from("board")
    //         .insert([boardPayload])
    //         .select()
    //         .single();

    //       if (error) {
    //         console.error("Error creating board:", error);
    //         return;
    //       }

    //       console.log("Board created:", data);
    //     };

    //     createBoard();
    //   }, []);


    //   {todos.length === 0 ? (
    //     <p>No records found</p>
    //   ) : (
    //     <ul>
    //       {todos.map((todo) => (
    //         <li key={todo.id}>
    //           {JSON.stringify(todo)}
    //         </li>
    //       ))}
    //     </ul>
    //   )}

    if (loading) return <div>
        <Pageloader isLoading={loading} />
    </div>

    return (
        <>
            <div className="bg-white p-4 gap-4 position-relative vh-100 d-flex flex-column">
                <div className="d-flex justify-content-between gap-2">
                    {/* <CButton color="primary"
                    className=''
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: "max-content"
                    }}
                    onClick={() => setVisible(true)}>Add New Task</CButton> */}


                    <span className='d-flex align-items-center gap-2'>
                        <CButton variant="outline" onClick={() => setShowBoards((p) => !p)}>
                            <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M19 6C19.5523 6 20 5.55228 20 5C20 4.44772 19.5523 4 19 4C18.4477 4 18 4.44772 18 5C18 5.55228 18.4477 6 19 6Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M19 20C19.5523 20 20 19.5523 20 19C20 18.4477 19.5523 18 19 18C18.4477 18 18 18.4477 18 19C18 19.5523 18.4477 20 19 20Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M5 6C5.55228 6 6 5.55228 6 5C6 4.44772 5.55228 4 5 4C4.44772 4 4 4.44772 4 5C4 5.55228 4.44772 6 5 6Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M5 20C5.55228 20 6 19.5523 6 19C6 18.4477 5.55228 18 5 18C4.44772 18 4 18.4477 4 19C4 19.5523 4.44772 20 5 20Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </CButton>
                        <h5 class="card-title m-0 py-0 p-0">Dashboard</h5>
                    </span>

                    <CButton
                        color="primary"
                        variant="outline"
                        className=""
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: 'max-content',
                        }}
                        onClick={() => setEditModalVisible((p) => !p)}
                    >
                        <Plus className="mx-1" />
                        Add Board
                    </CButton>

                </div>
                <AnimatePresence>
                    {showBoards && (
                        <>
                            <div
                                onClick={(e) => {
                                    e.stopPropagation()
                                    setShowBoards(!showBoards)
                                }}
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    right: 0,
                                    bottom: 0,
                                    width: '100%',
                                    height: '100vh',
                                    zIndex: 1000000000,
                                    background: '#6b656545',
                                    display: showBoards ? 'block' : 'none',
                                }}
                            ></div>
                            <motion.div
                                initial={{
                                    opacity: 0,
                                    x: showBoards ? '-100%' : '0',
                                }}
                                animate={{
                                    opacity: 1,
                                    x: showBoards ? '0' : '-100%',
                                }}
                                className="board-sidebar"
                                style={{
                                    position: 'absolute',
                                    overflow: 'hidden',
                                    overflowY: 'auto',
                                    bottom: 0,
                                    left: 0,
                                    translateX: showBoards ? '0' : '-100%',
                                    padding: '1rem',
                                    zIndex: 1000000000,
                                    height: '100vh',
                                    width: '300px',
                                    background: '#fff',
                                }}
                            >
                                <a
                                    href="/dashboard/tempBacklog"
                                    style={{
                                        // element.style {
                                        //     padding-bottom: 18px!important;
                                        //     padding-top: 10px!important;
                                        //     /* border-bottom: 1px solid red; */
                                        //     color: #000;
                                        // }
                                        paddingBottom: '18px!important',
                                        color: '#000',
                                        paddingTop: '10px!important',
                                    }}
                                    className="d-flex pb-1 align-items-center gap-2 p-2 mb-3"
                                >
                                    <span style={{ lineHeight: 0 }}>
                                        <LayoutPanelLeft size={20} strokeWidth={1} />
                                    </span>
                                    <CCardTitle
                                        style={{
                                            fontSize: '17px',
                                            color: '#4d4a4a',
                                        }}
                                        className="p-0 m-0"
                                    >
                                        Dashboard
                                    </CCardTitle>
                                </a>
                                {todos.map((brd, idx) => {
                                    const isActive =
                                        localStorage?.getItem('selected-board-id') == brd?.id

                                    return (
                                        <motion.div
                                            key={idx}
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1 }}
                                            exit={{ opacity: 0 }}
                                            className="w-100"
                                        >
                                            <div
                                                onClick={() => {
                                                    setSelectedBoardId(brd.id)
                                                    // setSelectedBoardToDisplay(brd)
                                                    setShowBoards(false)
                                                    localStorage.setItem('selected-board-id', brd.id)
                                                    localStorage.setItem('selected-boards', JSON.stringify(brd))
                                                    window.location.href = `/home/kanban/${brd?.id}`;
                                                }}
                                                className={`d-flex align-items-center w-100 px-3 py-2 rounded 
                                                            ${isActive ? 'fw-semibold' : ''}`}
                                                style={{
                                                    cursor: 'pointer',
                                                    background: isActive
                                                        ? 'rgba(14, 130, 119, 0.12)'
                                                        : 'transparent',
                                                    transition: 'background 0.2s ease',
                                                }}
                                                onMouseEnter={(e) => (e.currentTarget.style.background = 'rgba(14,130,119,0.08)')}
                                                onMouseLeave={(e) =>
                                                (e.currentTarget.style.background = isActive
                                                    ? 'rgba(14,130,119,0.12)'
                                                    : 'transparent')
                                                }

                                            >
                                                <span
                                                    className="text-truncate"
                                                    style={{
                                                        maxWidth: '100%',
                                                        fontSize: '14px',
                                                        color: isActive ? '#0e8277' : '#444',
                                                    }}
                                                    title={brd?.title}
                                                >
                                                    {brd?.title}
                                                </span>
                                            </div>
                                        </motion.div>
                                    )
                                })}


                            </motion.div>

                        </>
                    )}

                </AnimatePresence>
                <div className='d-flex align-items-center justify-content-end gap-2'>
                    <div style={{ position: "relative", display: "inline-block" }}>
                        <CFormInput
                          
                            type="date"
                            color="primary"
                            value={filters.date || ""}
                            aria-describedby="exampleFormControlInputHelpInline"
                            onChange={(e) => {
                                setFilters((p) => ({
                                    ...p,
                                    date: e.target.value
                                }));
                            }}
                        />
                        {filters.date && (
                            <button
                                className='d-flex align-items-center justify-content-center'
                                onClick={() => setFilters((p) => ({ ...p, date: "" }))}
                                style={{
                                    position: "absolute",
                                    right: "12px",
                                    top: "50%",
                                    width: "20px",
                                    height: "20px",
                                    transform: "translateY(-50%)",
                                    background: "black",
                                    border: "none",
                                    cursor: "pointer",
                                    borderRadius: "100px",
                                    color: "#fff",
                                }}
                            >
                                <X className='' strokeWidth={3} size={30} />
                            </button>
                        )}
                    </div>
                    {/* 
                    <Select
                        className="w-25"
                        isClearable
                        aria-label="Default select example"
                        placeholder="Select Users"
                        options={[...users].map((usr) => ({
                            label: usr.label,
                            value: usr.name,
                        }))}
                        onChange={(e) => {
                            console.log(e)
                            setFilters({ ...filters, assignee: e ? e : null })
                        }}
                        value={
                            filters.assignee
                                ? { label: filters.assignee, value: filters.assignee }
                                : null
                        }
                        styles={{
                            control: (base) => ({
                                ...base,
                                minHeight: '48px',
                                height: '48px',
                            }),
                            valueContainer: (base) => ({
                                ...base,
                                padding: '0 12px',
                                height: '48px',
                            }),
                            indicatorsContainer: (base) => ({
                                ...base,
                                height: '48px',
                            }),
                            input: (base) => ({
                                ...base,
                                margin: 0,
                                padding: 0,
                            }),
                        }}
                    /> */}

                    <Select
                        className="w-25"
                        isClearable
                        placeholder="Select Users"
                        options={users}
                        value={
                            users.find(u => u.label === filters.assignee) || null
                        }

                        onChange={(option) => {
                            setFilters({
                              
                                ...filters,
                                assignee: option ? option.label : '',
                            })
                        }}

                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.value.toString()}
                    />



                    <CButton
                        variant='outline'
                        color='primary'
                        onClick={() => {
                            setFilters({ ...filters, date: "", assignee: "" })
                        }}
                    >Clear</CButton>
                </div>
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col">Task</th>
                            <th scope="col">Assigned To</th>
                            <th scope="col">Status</th>
                            <th scope="col">Due Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            filteredTasks().map((task, index) => {
                                return (
                                    <tr key={index}>
                                        <td style={{}} className="">
                                            <span
                                                onClick={() => {
                                                    console.log(task, 'task')
                                                    localStorage.setItem('selected-board-id', task.boardId)
                                                    localStorage.setItem('selected-boards', JSON.stringify(task))
                                                    window.location.href = `/home/kanban/${task.boardId}`
                                                }}
                                            >
                                                <div
                                                     style={{cursor:"pointer"}}
                                                className='text-primary '
                                                //  to={`/home/kanban`}
                                                >
                                                    {task?.title}
                                                </div>
                                            </span>
                                        </td>
                                        <td>{task.assignee || '-'}</td>
                                        <td>{task.status || '-'}</td>
                                        <td>{task.dueDate ? new Date(task.dueDate).toLocaleDateString('en-US') : '-'}</td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>

            </div>


            <CModal visible={editModalVisible} onClose={() => setEditModalVisible(false)}>
                <CModalHeader>
                    <CModalTitle>Add Board</CModalTitle>
                </CModalHeader>
                <CModalBody>
                    <div className="d-flex flex-column gap-2">
                        <span className="">
                            <CFormLabel>Title</CFormLabel>
                            <CFormInput
                                style={{
                                    border: '0',
                                    background: '#8080800d',
                                }}
                                placeholder="Title"
                                name="Title"
                                value={createBoardState.title}
                                onChange={(e) => {
                                    setCreateBoardState((p) => ({
                                        ...p,
                                        title: e.target.value,
                                    }))
                                }}
                            />
                        </span>
                        <span className="">
                            <CFormLabel>Description</CFormLabel>
                            <CFormTextarea
                                aria-rowcount={10}
                                style={{
                                    height: '150px',
                                    border: '0',
                                    background: '#8080800d',
                                }}
                                placeholder="Description"
                                name="Summary"
                                onChange={(e) => {
                                    setCreateBoardState((p) => ({
                                        ...p,
                                        description: e.target.value,
                                    }))
                                }}
                            />
                        </span>
                        <div className="d-flex justify-between-end w-full w-100">
                            <CButton variant="outline" color="primary"
                                onClick={() => {
                                    setCreateBoardState((p) => ({
                                        ...p,
                                        columns: [
                                            ...p.columns,
                                            { headerText: 'To Do', keyField: Date.now(), order: p.columns.length + 1, isCollapse: false },
                                            //...createBoardState.columns,
                                        ],
                                    }))
                                }}
                            >Add Columns</CButton>
                        </div>
                        {/* <div className="d-flex justify-content-end align-items-end">
                            <CButton
                                className=""
                                variant="outline"
                                onClick={() => {
                                    setCreateBoardState((p) => ({
                                        ...p,
                                        columns: [
                                            ...p.columns,
                                            { headerText: 'To Do', keyField: 'To Do' },
                                            //...createBoardState.columns,
                                        ],
                                    }))
                                }}
                            >
                                Add Columns
                            </CButton>
                        </div> */}
                        {createBoardState.columns.length > 0 && (
                            <div className="d-flex flex-column gap-1">
                                <CFormLabel>Columns</CFormLabel>
                                {createBoardState.columns.map((item, idx) => {
                                    return (
                                        <div key={idx} className="d-flex align-items-center gap-2">
                                            <CFormInput
                                                placeholder={`Add Column ${idx + 1}`}
                                                name={`columns[${idx}].name`}
                                                value={item.headerText}
                                                onChange={(e) => {
                                                    setCreateBoardState((p) => ({
                                                        ...p,
                                                        columns: p.columns.map((i, j) => {
                                                            if (j === idx) {
                                                                return { ...i, headerText: e.target.value, }
                                                            }
                                                            return i
                                                        }),
                                                    }))
                                                }}
                                            />
                                            <CButton
                                                variant="outline"
                                                onClick={() => {
                                                    setCreateBoardState((p) => ({
                                                        ...p,
                                                        columns: p.columns.filter((_, i) => i !== idx),
                                                    }))
                                                }}
                                                className=""
                                                color="danger"
                                            >
                                                Delete
                                            </CButton>
                                        </div>
                                    )
                                })}
                            </div>
                        )}
                    </div>
                </CModalBody>
                <CModalFooter className="p-4">
                    <CButton variant="outline" color="secondary" onClick={() => {
                        setEditModalVisible(false), setCreateBoardState({
                            id: Date.now(),
                            title: '',
                            description: '',
                            tasks: [],
                            columns: []
                        })
                    }}>Close</CButton>
                    <CButton 
                      disabled={!createBoardState.title || !createBoardState.description || !createBoardState.columns.length > 0}
                     variant="outline" color="primary" onClick={() => handleSaveBoard()}>Save Changes</CButton>
                </CModalFooter>
            </CModal>
        </>
    )
}

export default TempBacklog
